<template>
    <div class="col-12 align-self-center">
        <div class="card h-100">
            <div class="card-body p-sm-3 p-md-5 d-flex flex-column">
                <div class="text-center">
                    <h4>{{$t('before_title')}}</h4>
                    <p>{{$t('before_text')}}</p>
                    <p v-if="this.$state.login_info.restartdetected === 1">
                        {{$t('before_text_resume')}}
                    </p>
                    <button class="btn btn-success btn-lg" @click="next">{{$t('before_button')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            next() {
                this.$router.push({name: 'sequenceStep'});
            }
        }
    }
</script>
